import { ButtonText } from '#organisims/DashboardCustomerInfo/styles';

interface SaveButtonProps {
  onClick: () => void;
}

const SaveButton = ({ onClick }: SaveButtonProps) => {
  return <ButtonText onClick={onClick}>저장</ButtonText>;
};

export default SaveButton;
